<template>
  <div>
    <div class="instagram-toolbar-color">
      <v-container>
        <v-row class="text-center" justify="center" align="center">
          <v-col cols="2" sm="2" md="1" lg="1">
            <v-tooltip v-if="isLoggedInUser" bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  @click="backToSubscription()"
                  v-bind="attrs"
                  v-on="on"
                  color="white"
                  dense
                  icon
                >
                  <v-icon>mdi-arrow-left-bold-circle</v-icon>
                </v-btn>
              </template>
              <span>Back To Subscription</span>
            </v-tooltip>
          </v-col>
          <v-col cols="8" sm="8" md="10" lg="10">
            <h2 class="white--text hidden-sm-and-down">
              Instagram Insights Report
            </h2>
            <h3 class="white--text hidden-md-and-up">
              Instagram Insights Report
            </h3>
          </v-col>
          <v-col cols="2" sm="2" md="1" lg="1">
            <v-menu v-model="menuOpen" offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="white"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  rounded
                  fab
                  small
                >
                  <v-icon dense color="primary">mdi-filter-variant</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                  v-for="section in selectSections"
                  :key="section.value"
                >
                  <v-list-item-title>{{ section.name }}</v-list-item-title>
                  <v-list-item-action>
                    <v-checkbox
                      v-model="selectedSections"
                      :value="section.value"
                      @click.stop
                    ></v-checkbox>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <div class="lightgrey" v-if="selectedSections.includes('campaignSection')">
      <v-container>
        <v-row>
          <v-col cols="12" class="my-6 text-center">
            <h1>Campaign Overview</h1>
            <p>Quick glance at the Performance totals from the last 30 Days</p>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <div v-if="selectedSections.includes('campaignSection')">
      <v-container
        v-if="this.selectedInsightsReport.instagramCampaignData != null"
      >
        <v-row justify="center" align="center" class="text-center my-3">
          <v-col cols="12">
            <h2>Overall Totals</h2>
          </v-col>
          <v-col cols="6" sm="6" md="2" lg="2">
            <v-card>
              <v-card-text>
                <h4>Total Campaigns</h4>
                {{ this.campaignsTotals.totalCampaigns }}
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="6" sm="6" md="2" lg="2">
            <v-card>
              <v-card-text>
                <h4>Total Impressions</h4>
                {{ this.campaignsInstagramTotals.instagramTotalImpressions }}
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="6" sm="6" md="2" lg="2">
            <v-card>
              <v-card-text>
                <h4>Total Reach</h4>
                {{ this.campaignsInstagramTotals.instagramTotalReach }}
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="6" sm="6" md="2" lg="2">
            <v-card>
              <v-card-text>
                <h4>Total Clicks</h4>
                {{ this.campaignsInstagramTotals.instagramTotalClicks }}
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="6" sm="6" md="2" lg="2">
            <v-card>
              <v-card-text>
                <h4>Total Facebook Spend</h4>
                ZAR{{
                  this.campaignsFacebookTotals.facebookTotalSpend
                    | formatTotalAmount
                }}
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="6" sm="6" md="2" lg="2">
            <v-card>
              <v-card-text>
                <h4>Total Instagram Spend</h4>
                ZAR{{
                  this.campaignsInstagramTotals.instagramTotalSpend
                    | formatTotalAmount
                }}
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="6" sm="6" md="2" lg="2">
            <v-card>
              <v-card-text>
                <h4>Total Spend</h4>
                ZAR{{
                  this.campaignsTotals.campaignsTotalSpend | formatTotalAmount
                }}
              </v-card-text>
            </v-card>
          </v-col>
          <v-col
            v-if="this.performanceByPlacement.length != 0"
            cols="12"
            class="text-center my-3"
          >
            <h2>Preformance By Social Placement</h2>
            <v-data-table
              :headers="headers"
              :items="performanceByPlacement"
              :items-per-page="12"
              hide-default-footer
              class="elevation-1"
            >
              <template v-slot:[`item.spend`]="{ item }">
                ZAR {{ item.spend | toFixed2 }}
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-container>
      <v-container v-else>
        <v-row>
          <v-col cols="12" class="text-center">
            <p class="mb-0">No Data</p>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <div class="lightgrey" v-if="selectedSections.includes('adset')">
      <v-container>
        <v-row>
          <v-col cols="12" class="my-6 text-center">
            <h1>Adsets Overview</h1>
            <p>Quick glance at the Adsets totals from the last 30 Days</p>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <div v-if="selectedSections.includes('adset')" class="pb-5">
      <v-container v-if="this.selectedInsightsReport.instagramAdData != null">
        <v-row justify="center" align="center" class="text-center mt-2">
          <v-col cols="12">
            <h2>Overall Totals</h2>
          </v-col>
          <v-col cols="6" sm="6" md="2" lg="2">
            <v-card>
              <v-card-text>
                <h5>Total Ads</h5>
                {{ this.instagramTotals.total_ads }}
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="6" sm="6" md="2" lg="2">
            <v-card>
              <v-card-text>
                <h5>Total Clicks</h5>
                {{ this.adsetInstagramTotal.instagramClicks }}
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="6" sm="6" md="2" lg="2">
            <v-card>
              <v-card-text>
                <h5>Total Impressions</h5>
                {{ this.adsetInstagramTotal.instagramImpressions }}
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="6" sm="6" md="2" lg="2">
            <v-card>
              <v-card-text>
                <h5>Total Reach</h5>
                {{ this.adsetInstagramTotal.instagramReach }}
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="6" sm="6" md="2" lg="2">
            <v-card>
              <v-card-text>
                <h5>Total Facebook Spend</h5>
                ZAR{{
                  this.adsetFacebookTotal.facebookSpend | formatTotalAmount
                }}
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="6" sm="6" md="2" lg="2">
            <v-card>
              <v-card-text>
                <h5>Total Instagram Spend</h5>
                ZAR{{
                  this.adsetInstagramTotal.instagramSpend | formatTotalAmount
                }}
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="6" sm="6" md="2" lg="2">
            <v-card>
              <v-card-text>
                <h5>Total Spend</h5>
                ZAR{{ this.instagramTotals.total_spend | formatTotalAmount }}
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12">
            <v-divider class="mb-3"></v-divider>
            <h2>Averages</h2>
            <apexchart
              type="bar"
              height="350"
              :options="chartOptionsAdsAverages"
              :series="this.averages"
            >
            </apexchart>
          </v-col>
          <v-col cols="12">
            <v-divider class="mb-3"></v-divider>
            <h2>Overview On Adsets</h2>
            <v-row justify="center" align="center" class="pt-5">
              <v-col
                cols="12"
                sm="12"
                md="3"
                lg="3"
                v-for="adset in this.adsAdsets"
                :key="adset.id"
              >
                <v-card min-height="200px">
                  <v-card-text>
                    <v-row>
                      <v-col cols="12" class="pb-0">
                        <h4 class="cardtitle">{{ adset.name }}</h4>
                        <p class="mb-0">
                          {{ adset.created_time | formatAdsetsDate }}
                        </p>
                        <v-divider></v-divider>
                      </v-col>
                      <v-col cols="4" class="px-1 py-2">
                        <v-card class="primary white--text">
                          <p class="mb-0 cardfont">Clicks</p>
                          <p class="mb-0">
                            {{ adset.adsetTotalsInstagram.clicks }}
                          </p>
                        </v-card>
                      </v-col>
                      <v-col cols="4" class="px-1 py-2">
                        <v-card class="compeatsecondary white--text">
                          <p class="mb-0 cardfont">Impressions</p>
                          <p class="mb-0">
                            {{ adset.adsetTotalsInstagram.impressions }}
                          </p>
                        </v-card>
                      </v-col>
                      <v-col cols="4" class="px-1 py-2">
                        <v-card class="thertiarty white--text">
                          <p class="mb-0 cardfont">Reach</p>
                          <p class="mb-0">
                            {{ adset.adsetTotalsInstagram.reach }}
                          </p>
                        </v-card>
                      </v-col>
                      <v-col cols="12" class="py-0">
                        <v-divider class="mb-1"></v-divider>
                        <h4 v-if="adset.adsetTotalsInstagram.spend">
                          Spend: ZAR
                          {{
                            adset.adsetTotalsInstagram.spend | formatTotalAmount
                          }}
                        </h4>
                        <h4 v-else>Spend: ZAR 0,00</h4>
                      </v-col>
                      <v-col cols="12" class="pt-0 pb-2">
                        <v-divider class="mt-1 mb-2"></v-divider>
                        <v-chip
                          color="success"
                          small
                          v-if="adset.status == 'ACTIVE'"
                          >{{ adset.status }}</v-chip
                        >
                      </v-col>
                    </v-row>
                  </v-card-text>
                  <v-card-actions>
                    <v-row>
                      <v-col cols="12" class="text-center">
                        <v-dialog
                          transition="dialog-bottom-transition"
                          fullscreen
                          hide-overlay
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              color="primary"
                              rounded
                              small
                              v-bind="attrs"
                              v-on="on"
                              >View Insights</v-btn
                            >
                          </template>
                          <template v-slot:default="dialog">
                            <v-card>
                              <v-toolbar color="primary" dark>
                                <v-btn icon dark @click="dialog.value = false">
                                  <v-icon>mdi-close</v-icon>
                                </v-btn>
                                <v-toolbar-title
                                  >Insights For
                                  {{ adset.name }}</v-toolbar-title
                                >
                              </v-toolbar>
                              <v-card-text>
                                <v-row
                                  class="py-5"
                                  justify="center"
                                  align="center"
                                >
                                  <v-col cols="6">
                                    <h2 class="mb-3">Adset Overview</h2>
                                  </v-col>
                                  <v-col cols="6" class="text-right">
                                    <viewAds :ads="adset.ads.data" />
                                  </v-col>
                                  <v-col cols="12" sm="12" md="6" lg="6">
                                    <v-row>
                                      <v-col cols="12">
                                        <v-card class="px-2 py-2">
                                          <v-row>
                                            <v-col cols="12" class="pb-0">
                                              <h2>Ad Info & Settings</h2>
                                            </v-col>
                                            <v-col cols="12" class="pb-0">
                                              <b>Account Name:</b>
                                              {{ adset.name }}
                                            </v-col>
                                            <v-col
                                              cols="12"
                                              sm="12"
                                              md="6"
                                              lg="6"
                                            >
                                              <b>Start Date:</b>
                                              Need Date
                                            </v-col>
                                            <v-col
                                              cols="12"
                                              sm="12"
                                              md="6"
                                              lg="6"
                                            >
                                              <b>End Date:</b>
                                              Need Date
                                            </v-col>
                                            <v-col
                                              cols="12"
                                              sm="12"
                                              md="6"
                                              lg="6"
                                              class="pt-0"
                                            >
                                              <b>Total Spend:</b>
                                              {{
                                                adset.adsetTotalsInstagram.spend
                                                  | formatTotalAmount
                                              }}
                                            </v-col>
                                            <v-col cols="12">
                                              <v-divider></v-divider>
                                            </v-col>
                                            <v-col cols="12" class="pt-0">
                                              <h2>Ad Targeting</h2>
                                            </v-col>
                                            <v-col
                                              cols="12"
                                              sm="12"
                                              md="6"
                                              lg="6"
                                            >
                                              <b>Min Age:</b>
                                              {{ adset.targeting.age_min }}
                                            </v-col>
                                            <v-col
                                              cols="12"
                                              sm="12"
                                              md="6"
                                              lg="6"
                                            >
                                              <b>Max Age:</b>
                                              {{ adset.targeting.age_max }}
                                            </v-col>
                                          </v-row>
                                        </v-card>
                                      </v-col>
                                    </v-row>
                                  </v-col>
                                  <v-col cols="12" sm="12" md="6" lg="6">
                                    <h2 class="mb-3"></h2>
                                    <v-row>
                                      <v-col cols="12" sm="12" md="4" lg="4">
                                        <v-card
                                          dark
                                          color="primary"
                                          class="px-2"
                                        >
                                          <v-row>
                                            <v-col
                                              cols="12"
                                              class="text-center"
                                            >
                                              <b>Total Clicks</b>
                                              <p class="mb-0">
                                                {{
                                                  adset.adsetTotalsInstagram
                                                    .clicks
                                                }}
                                              </p>
                                            </v-col>
                                          </v-row>
                                        </v-card>
                                      </v-col>
                                      <v-col cols="12" sm="12" md="4" lg="4">
                                        <v-card
                                          dark
                                          color="compeatsecondary"
                                          class="px-2"
                                        >
                                          <v-row>
                                            <v-col
                                              cols="12"
                                              class="text-center"
                                            >
                                              <b>Total Impressions</b>
                                              <p class="mb-0">
                                                {{
                                                  adset.adsetTotalsInstagram
                                                    .impressions
                                                }}
                                              </p>
                                            </v-col>
                                          </v-row>
                                        </v-card>
                                      </v-col>
                                      <v-col cols="12" sm="12" md="4" lg="4">
                                        <v-card
                                          dark
                                          color="compeatthird"
                                          class="px-2"
                                        >
                                          <v-row>
                                            <v-col
                                              cols="12"
                                              class="text-center"
                                            >
                                              <b>Total Reach</b>
                                              <p class="mb-0">
                                                {{
                                                  adset.adsetTotalsInstagram
                                                    .reach
                                                }}
                                              </p>
                                            </v-col>
                                          </v-row>
                                        </v-card>
                                      </v-col>
                                      <v-col cols="12">
                                        <v-card class="px-2 py-2">
                                          <v-row>
                                            <v-col cols="12" class="pb-0">
                                              <h2>Costings</h2>
                                            </v-col>
                                            <v-col
                                              cols="6"
                                              sm="6"
                                              md="3"
                                              lg="3"
                                            >
                                              <b>CPC:</b>
                                              {{
                                                adset.costAverages.cpc
                                                  | toFixed2
                                              }}
                                            </v-col>
                                            <v-col
                                              cols="6"
                                              sm="6"
                                              md="3"
                                              lg="3"
                                            >
                                              <b>CPM:</b>
                                              {{
                                                adset.costAverages.cpm
                                                  | toFixed2
                                              }}
                                            </v-col>
                                            <v-col
                                              cols="6"
                                              sm="6"
                                              md="3"
                                              lg="3"
                                            >
                                              <b>CPP:</b>
                                              {{
                                                adset.costAverages.cpp
                                                  | toFixed2
                                              }}
                                            </v-col>
                                            <v-col
                                              cols="6"
                                              sm="6"
                                              md="3"
                                              lg="3"
                                            >
                                              <b>CTR:</b>
                                              {{
                                                adset.costAverages.ctr
                                                  | toFixed2
                                              }}
                                            </v-col>
                                            <v-col
                                              cols="6"
                                              sm="6"
                                              md="3"
                                              lg="3"
                                            >
                                              <b>CPIPE:</b>
                                              {{
                                                adset.costAverages
                                                  .cost_per_inline_post_engagement
                                                  | toFixed2
                                              }}
                                            </v-col>
                                          </v-row>
                                        </v-card>
                                      </v-col>
                                    </v-row>
                                  </v-col>
                                  <v-col cols="12">
                                    <v-divider></v-divider>
                                  </v-col>
                                  <v-col cols="12">
                                    <h2>Platform Breakdown</h2>
                                  </v-col>
                                  <v-col cols="12">
                                    <v-expansion-panels>
                                      <v-expansion-panel
                                        v-for="item in adset.instagramInsights"
                                        :key="item.id"
                                      >
                                        <v-expansion-panel-header>
                                          {{
                                            item.platform_position
                                              | transformTitle
                                          }}
                                          <v-spacer></v-spacer>
                                          {{ item.account_currency }}
                                          {{ item.spend | formatTotalAmount }}
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                          <v-row
                                            justify="center"
                                            align="center"
                                          >
                                            <v-col
                                              cols="12"
                                              sm="12"
                                              md="6"
                                              lg="6"
                                            >
                                              <v-card class="px-2 py-2">
                                                <v-row>
                                                  <v-col cols="12" class="pb-0">
                                                    <h2>Ad Info & Settings</h2>
                                                  </v-col>
                                                  <v-col cols="12" class="pb-0">
                                                    <b>Account Name:</b>
                                                    {{ item.account_name }}
                                                  </v-col>
                                                  <v-col
                                                    cols="12"
                                                    sm="12"
                                                    md="6"
                                                    lg="6"
                                                  >
                                                    <b>Start Date:</b>
                                                    {{ item.date_start }}
                                                  </v-col>
                                                  <v-col
                                                    cols="12"
                                                    sm="12"
                                                    md="6"
                                                    lg="6"
                                                  >
                                                    <b>End Date:</b>
                                                    {{ item.date_stop }}
                                                  </v-col>
                                                  <v-col
                                                    cols="12"
                                                    sm="12"
                                                    md="6"
                                                    lg="6"
                                                    class="pt-0"
                                                  >
                                                    <b>Total Spend:</b>
                                                    {{ item.account_currency }}
                                                    {{
                                                      item.spend
                                                        | formatTotalAmount
                                                    }}
                                                  </v-col>
                                                </v-row>
                                              </v-card>
                                            </v-col>
                                            <v-col>
                                              <v-row>
                                                <v-col
                                                  cols="12"
                                                  sm="12"
                                                  md="4"
                                                  lg="4"
                                                >
                                                  <v-card
                                                    dark
                                                    color="primary"
                                                    class="px-2"
                                                  >
                                                    <v-row>
                                                      <v-col
                                                        cols="12"
                                                        class="text-center"
                                                      >
                                                        <b>Total Clicks</b>
                                                        <p class="mb-0">
                                                          {{ item.clicks }}
                                                        </p>
                                                      </v-col>
                                                    </v-row>
                                                  </v-card>
                                                </v-col>
                                                <v-col
                                                  cols="12"
                                                  sm="12"
                                                  md="4"
                                                  lg="4"
                                                >
                                                  <v-card
                                                    dark
                                                    color="compeatsecondary"
                                                    class="px-2"
                                                  >
                                                    <v-row>
                                                      <v-col
                                                        cols="12"
                                                        class="text-center"
                                                      >
                                                        <b>Total Impressions</b>
                                                        <p class="mb-0">
                                                          {{ item.impressions }}
                                                        </p>
                                                      </v-col>
                                                    </v-row>
                                                  </v-card>
                                                </v-col>
                                                <v-col
                                                  cols="12"
                                                  sm="12"
                                                  md="4"
                                                  lg="4"
                                                >
                                                  <v-card
                                                    dark
                                                    color="compeatthird"
                                                    class="px-2"
                                                  >
                                                    <v-row>
                                                      <v-col
                                                        cols="12"
                                                        class="text-center"
                                                      >
                                                        <b>Total Reach</b>
                                                        <p class="mb-0">
                                                          {{ item.reach }}
                                                        </p>
                                                      </v-col>
                                                    </v-row>
                                                  </v-card>
                                                </v-col>
                                                <v-col
                                                  cols="12"
                                                  sm="12"
                                                  md="12"
                                                  lg="12"
                                                >
                                                  <v-card class="px-2 py-2">
                                                    <v-row>
                                                      <v-col
                                                        cols="12"
                                                        class="pb-0"
                                                      >
                                                        <h2>Costings</h2>
                                                      </v-col>
                                                      <v-col
                                                        cols="6"
                                                        sm="6"
                                                        md="3"
                                                        lg="3"
                                                      >
                                                        <b>CPC:</b>
                                                        {{
                                                          item.cpc | toFixed2
                                                        }}
                                                      </v-col>
                                                      <v-col
                                                        cols="6"
                                                        sm="6"
                                                        md="3"
                                                        lg="3"
                                                      >
                                                        <b>CPM:</b>
                                                        {{
                                                          item.cpm | toFixed2
                                                        }}
                                                      </v-col>
                                                      <v-col
                                                        cols="6"
                                                        sm="6"
                                                        md="3"
                                                        lg="3"
                                                      >
                                                        <b>CPP:</b>
                                                        {{
                                                          item.cpp | toFixed2
                                                        }}
                                                      </v-col>
                                                      <v-col
                                                        cols="6"
                                                        sm="6"
                                                        md="3"
                                                        lg="3"
                                                      >
                                                        <b>CTR:</b>
                                                        {{
                                                          item.ctr | toFixed2
                                                        }}
                                                      </v-col>
                                                      <v-col
                                                        cols="6"
                                                        sm="6"
                                                        md="3"
                                                        lg="3"
                                                      >
                                                        <b>CPIPE:</b>
                                                        {{
                                                          item.cost_per_inline_post_engagement
                                                            | toFixed2
                                                        }}
                                                      </v-col>
                                                    </v-row>
                                                  </v-card>
                                                </v-col>
                                              </v-row>
                                            </v-col>
                                          </v-row>
                                        </v-expansion-panel-content>
                                      </v-expansion-panel>
                                    </v-expansion-panels>
                                  </v-col>
                                </v-row>
                              </v-card-text>
                            </v-card>
                          </template>
                        </v-dialog>
                      </v-col>
                    </v-row>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
      <v-container v-else>
        <v-row>
          <v-col cols="12" class="text-center">
            <p class="mb-0">No Data</p>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="120"
        >Please Wait...</v-progress-circular
      >
    </v-overlay>
  </div>
</template>

<script>
import donutChart from "@/components/charts/donutChart.vue";
import lineChart from "@/components/charts/lineChart.vue";
import barChartHorizontal from "../components/charts/barChartHorizontal.vue";
import viewAds from "../components/dialogs/viewAds.vue";
import { firebaseApp } from "../firebaseConfig";
import { getFirestore, doc, getDoc } from "firebase/firestore";
const db = getFirestore(firebaseApp);
import { getAuth, onAuthStateChanged } from "firebase/auth";
import moment from "moment-timezone";

export default {
  props: ["id", "uid", "reportId"],
  components: {
    donutChart,
    lineChart,
    barChartHorizontal,
    viewAds,
  },
  data: () => ({
    isLoggedInUser: false,
    selectedInsightsReport: [],
    selectedFacebookInsightsReport: [],
    campaignsSection: true,

    selectSections: [
      { name: "Campaigns Section", value: "campaignSection" },
      { name: "Adset Section", value: "adset" },
    ],
    selectedSections: [
      "campaignSection",
      "adset",
    ],
    headers: [
      {
        text: "Platform Name",
        align: "center",
        sortable: false,
        value: "name",
      },
      { text: "Clicks", align: "center", value: "clicks", sortable: false },
      {
        text: "Impressions",
        align: "center",
        value: "impressions",
        sortable: false,
      },
      { text: "Reach", align: "center", value: "reach", sortable: false },
      { text: "Spend", align: "center", value: "spend" },
    ],
    menuOpen: false,
    absolute: true,
    opacity: 1,
    overlay: false,
    title: "",

    instagramTotals: [],
    totalValues: [],
    instagramBasic: [],
    demographics: [],

    chartOptionsDemographicsCity: {},
    demographicsCitySeries: [],

    chartOptionsDemographicsCountry: {},
    demographicsCountrySeries: [],

    chartOptionsDemographicsGender: {},
    demographicsGenderSeries: [],

    chartOptionsDemographicsLocale: {},
    demographicsLocaleSeries: [],

    chartOptionsDaliyTimeImpressions: {},
    dailyTimeImpressionsSeries: [],

    dailyTimeReachSeries: [],
    dailyTimeImpressionsReachSeries: [],
    media: [],

    performanceByPlacement: [],
    performanceByPlacementData: [],

    chartOptionsAdsAverages: {},
    adsetAverages: [],
    adsHeadings: [],
    adsValues: [],
    averages: [],

    adsAdsets: [],
    campaigns: [],
    activeSubscription: false,
    pausedSubscription:false,
    cancelledSubscription:false,
    selectedSubscription: [],

    adsetInstagramTotal: [],
    adsetFacebookTotal: [],
    campaignsInstagramTotals: [],
    campaignsTotals: [],
    campaignsFacebookTotals: [],
  }),
  created() {
    this.getCurrentUser();
  },
  filters: {
    formatNumber(value) {
      return value.toFixed(2);
    },
    toFixed2(value) {
      if (!value) return "";
      return Number(value).toFixed(2);
    },
    formatTotalAmount: function (value) {
      if (!value) return "";
      return new Intl.NumberFormat("en-ZA", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(value);
    },
    formatTitles: function (value) {
      if (!value) return "";

      // Split the value by underscores
      const words = value.split("_");

      // Capitalize the first letter of each word and join them with spaces
      const formattedValue = words
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");

      return formattedValue;
    },
    formatAdsetsDate: function (value) {
      if (!value) return "";
      return moment(value).format("DD MMMM YYYY");
    },
    transformTitle(value) {
      return value
        .split("_")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
    },
  },
  methods: {
    getCurrentUser() {
      this.overlay = true;
      const auth = getAuth();
      onAuthStateChanged(auth, (user) => {
        if (user) {
          const getdata = async () => {
            const docRef = doc(db, "users", user.uid);
            const docSnap = await getDoc(docRef);
            let userRole = docSnap.data().userType;
            if (
              userRole == "SMM" ||
              userRole == "AA" ||
              userRole == "SB" ||
              userRole == "SA"
            ) {
              this.isLoggedInUser = true;
            }
          };
          getdata();
          this.getSubscription();
        } else {
          this.noUser = true;
          this.getSubscription();
        }
      });
    },
    async getSubscription() {
      this.overlay = true;
      try {
        const docRef = doc(db, "subscriptions", this.uid); // Use doc() to create a reference to the document
      const docSnapshot = await getDoc(docRef); // Use getDoc() to retrieve the document snapshot

      if (docSnapshot.exists()) {
        this.activeSubscription = true;
        this.selectedSubscription = docSnapshot.data();
        this.pagesLength = this.selectedSubscription.package.pages.length;

        if (this.pagesLength > 40) {
          this.height = "2000px";
        } else if (this.pagesLength > 30) {
          this.height = "1700px";
        } else if (this.pagesLength > 20) {
          this.height = "1300px";
        } else if (this.pagesLength > 10) {
          this.height = "900px";
        } else if (this.pagesLength > 5) {
          this.height = "400px";
        }
      } else {
        const cancelledSubscriptionDocRef = doc(db, "cancelledsubscriptions", this.uid);
        const cancelledSubscriptionSnapshot = await getDoc(cancelledSubscriptionDocRef);
        if (cancelledSubscriptionSnapshot.exists()) {
          this.cancelledSubscription = true;
          this.selectedSubscription = cancelledSubscriptionSnapshot.data();
        } else {
          const pausedSubscriptionDocRef = doc(db, "pausedsubscriptions", this.uid);
          const pausedSubscriptionSnapshot = await getDoc(pausedSubscriptionDocRef);
          if (pausedSubscriptionSnapshot.exists()) {
            this.pausedSubscription = true;
            this.selectedSubscription = pausedSubscriptionSnapshot.data();
          } else {
            this.overlay = false
            throw new Error("Document not found");
          }
        }
      }
        this.getReport();
      } catch (err) {
        console.log("err", err);
      }
    },
    async getReport() {
      try {
        const docRef = doc(db, "instagramReports", this.reportId); // Use doc() to create a reference to the document
        const docSnapshot = await getDoc(docRef); // Use getDoc() to retrieve the document snapshot

        if (!docSnapshot.exists()) {
          throw new Error("Document not found");
        }
        this.selectedInsightsReport = docSnapshot.data();

        if (
          this.selectedInsightsReport.instagramAdData != null &&
          this.selectedInsightsReport.instagramCampaignData != null
        ) {
          this.adsetAverages =
            this.selectedInsightsReport.instagramAdData.adsets.averages;
          this.campaigns =
            this.selectedInsightsReport.instagramCampaignData.campaigns;
          this.getAdsAverages();
        } else {
          this.overlay = false;
        }
      } catch (err) {
        console.log("err", err);
      }
    },
    getAdsAverages() {
      this.adsHeadings = [];
      this.adsValues = [];

      // Loop through each key in the object
      for (const key in this.adsetAverages) {
        if (this.adsetAverages.hasOwnProperty(key)) {
          const modifiedKey = key.includes("average_")
            ? key.replace("average_", "")
            : key;
          this.adsHeadings.push(modifiedKey);
          const value = parseFloat(this.adsetAverages[key]);
          this.adsValues.push(Number(value.toFixed(2)));
        }
      }
      this.averages = [
        {
          data: this.adsValues,
        },
      ];

      this.chartOptionsAdsAverages = {
        chart: {
          height: 350,
          events: {
            click: function (chart, w, e) {},
          },
        },
        plotOptions: {
          bar: {
            columnWidth: "45%",
            distributed: true,
          },
        },
        dataLabels: {
          enabled: false,
        },
        legend: {
          show: false,
        },
        xaxis: {
          categories: this.adsHeadings,
          labels: {
            style: {
              fontSize: "12px",
            },
          },
        },
      };

      this.getAdsetsData();
    },
    getAdsetsData() {
      //Adsets Data
      this.adsetInstagramTotal =
        this.selectedInsightsReport.instagramAdData.adsets.instagramTotals;
      this.adsetFacebookTotal =
        this.selectedInsightsReport.instagramAdData.adsets.facebookTotals;
      this.performanceByPlacementData =
        this.selectedInsightsReport.instagramCampaignData.campaigns.performanceByPlacement;
      this.instagramTotals =
        this.selectedInsightsReport.instagramAdData.adsets.totals;
      let adsAdsetsPlatform =
        this.selectedInsightsReport.instagramAdData.adsets.adsetsPlatform;
      let adsAdsetsOverall =
        this.selectedInsightsReport.instagramAdData.adsets.adsetsOverall;

      // Check if both arrays have the same length
      if (adsAdsetsOverall.length !== adsAdsetsPlatform.length) {
        console.error("Arrays must have the same length to join by index.");
        return;
      }

      // Join the arrays based on their indices
      this.adsAdsets = adsAdsetsOverall.map((value, index) => {
        return { ...value, ...adsAdsetsPlatform[index] };
      });

      this.getCampaignTotals();
    },
    getDemographicData() {
      let demographicCity = this.demographics.audience_city;
      let demographicCountry = this.demographics.audience_country;
      let demographicGender = this.demographics.audience_gender_age;
      let demographiclocale = this.demographics.audience_locale;

      const demographicCityData = this.prepareChartData(demographicCity);
      const demographicCountryData = this.prepareChartData(demographicCountry);
      const demographicGenderData = this.prepareChartData(demographicGender);
      const demographicLocaleData = this.prepareChartData(demographiclocale);

      this.chartOptionsDemographicsCity = {
        chart: {
          height: 500,
          events: {
            click: function (chart, w, e) {},
          },
        },
        plotOptions: {
          bar: {
            distributed: true,
          },
        },
        dataLabels: {
          enabled: false,
        },
        legend: {
          show: false,
        },
        xaxis: {
          categories: demographicCityData.categories,
          labels: {
            style: {
              fontSize: "8px",
            },
          },
        },
      };
      this.demographicsCitySeries = demographicCityData.series;

      this.chartOptionsDemographicsCountry = {
        chart: {
          height: 500,
          events: {
            click: function (chart, w, e) {},
          },
        },
        plotOptions: {
          bar: {
            distributed: true,
            horizontal: true,
          },
        },
        dataLabels: {
          enabled: false,
        },
        legend: {
          show: false,
        },
        xaxis: {
          categories: demographicCountryData.categories,
          labels: {
            style: {
              fontSize: "8px",
            },
          },
        },
      };
      this.demographicsCountrySeries = demographicCountryData.series;

      this.chartOptionsDemographicsGender = {
        labels: demographicGenderData.categories,
        dataLabels: {
          enabled: false,
        },
        responsive: [
          {
            breakpoint: 960,
            options: {
              chart: {
                width: 290,
              },
              legend: {
                show: true,
              },
            },
          },
        ],
        legend: {
          position: "bottom",
        },
      };

      this.demographicsGenderSeries = demographicGenderData.series[0].data;

      this.chartOptionsDemographicsLocale = {
        chart: {
          height: 500,
          events: {
            click: function (chart, w, e) {},
          },
        },
        plotOptions: {
          bar: {
            distributed: true,
            horizontal: true,
          },
        },
        dataLabels: {
          enabled: false,
        },
        legend: {
          show: false,
        },
        xaxis: {
          categories: demographicLocaleData.categories,
          labels: {
            style: {
              fontSize: "8px",
            },
          },
        },
      };

      this.demographicsLocaleSeries = demographicLocaleData.series;

      this.getdailyTimeSeries();
    },
    getdailyTimeSeries() {
      let dailyImpressions = this.dailyTimeSeries.impressions;
      let dailyReach = this.dailyTimeSeries.reach;
      let dates = this.dailyTimeSeries.impressionsDates;

      const dailyTimeDates = this.prepareChartDataDaliyTimes(dates);

      this.chartOptionsDaliyTimeImpressions = {
        chart: {
          zoom: {
            enabled: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "smooth",
        },
        grid: {
          row: {
            colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
            opacity: 0.5,
          },
        },
        xaxis: {
          categories: dailyTimeDates.dates,
        },
      };

      this.dailyTimeImpressionsReachSeries = [
        {
          name: "Impressions",
          data: dailyImpressions,
        },
        {
          name: "Reach",
          data: dailyReach,
        },
      ];

      this.getCampaignTotals();
    },
    getCampaignTotals() {
      this.campaignsInstagramTotals = this.campaigns.instagramTotals;
      this.campaignsTotals = this.campaigns.totals;
      this.campaignsFacebookTotals = this.campaigns.facebookTotals;

      this.getPlacementsSeries();
    },
    getPlacementsSeries() {
      let arr = this.performanceByPlacementData;
      this.performanceByPlacement = Object.entries(arr)
        .filter(([name]) => name.includes("instagram"))
        .map(([name, data]) => {
          // Remove "facebook" substring and underscores
          let modifiedName = name.replace(/instagram|_/gi, " ");

          // Add spaces between words
          modifiedName = modifiedName.replace(/([a-z])([A-Z])/g, "$1 $2");
          modifiedName = modifiedName.replace(/([A-Z])([A-Z][a-z])/g, "$1 $2");

          // Capitalize the first letter of each word
          modifiedName = modifiedName.replace(/\b\w/g, function (l) {
            return l.toUpperCase();
          });

          return { name: modifiedName, ...data };
        });

      this.overlay = false;
    },
    prepareChartData(audienceCityData) {
      const categories = Object.keys(audienceCityData);
      const series = Object.values(audienceCityData);

      return {
        categories,
        series: [
          {
            name: "Users",
            data: series,
          },
        ],
      };
    },
    prepareChartDataDaliyTimes(data) {
      const dates = [];

      for (const item of data) {
        const date = moment(item).format("YYYY-MM-DD");
        dates.push(date);
      }

      return {
        dates,
      };
    },
    backToSubscription() {
      if (this.activeSubscription == true) {
        this.$router.push({
          name: "singleSubscription",
          params: {
            uid: this.uid,
          },
        });
      } else if (this.cancelledSubscription == true) {
        this.$router.push({
          name: "singleCancelledSubscription",
          params: {
            uid: this.uid,
          },
        });
      }else if (this.pausedSubscription == true) {
        this.$router.push({
          name: "singlePausedSubscription",
          params: {
            uid: this.uid,
          },
        });
      }
    },
    closeInsights() {
      this.overlay = !this.overlay;
    },
  },
};
</script>

<style>
.bg {
  background-color: #3d6eb1;
  height: 100%;
}

.expanbg {
  background-image: url("../assets/Compeat-dash-test.jpg");
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}

.apexcharts-canvas {
  width: auto !important;
}

.apexcharts-toolbar {
  z-index: 8 !important;
}

.posttext {
  font-size: 12px;
}
</style>
